// redux/slices/envSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  baseUrl: process.env.REACT_APP_BASE_URL,  // Load from environment variables
  prodTestUrl: process.env.REACT_APP_PROD_TEST_URL,
  isProduction: process.env.IS_PRODUCTION,
  prodImageUrl: process.env.prodUrl,
  devImageUrl: process.env.devUrl
};

const envSlice = createSlice({
  name: "env",
  initialState,
  reducers: {},
});

export const selectBaseUrl = (state) => state.env.baseUrl;
export const selectProdTestUrl = (state) => state.env.prodTestUrl;
export const selectProdBoolean = (state) => state.env.isProduction;
export const selectProdImageUrl = (state) => state.env.prodImageUrl;
export const selectDevImageUrl = (state) => state.env.devImageUrl;


export default envSlice.reducer;
